"use client";

import { Link } from "@/i18n/navigation";
import { useEffect } from "react";
import { CustomButton } from "@/components/ui/custom-button";
import * as Sentry from "@sentry/nextjs";

function FrownIcon(props) {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<circle
				cx="12"
				cy="12"
				r="10"
			/>
			<path d="M16 16s-1.5-2-4-2-4 2-4 2" />
			<line
				x1="9"
				x2="9.01"
				y1="9"
				y2="9"
			/>
			<line
				x1="15"
				x2="15.01"
				y1="9"
				y2="9"
			/>
		</svg>
	);
}

export default function ErrorPage({ error }: { error: Error & { digest?: string } }) {
	useEffect(() => {
		document.body.style.overflow = "hidden";
		return () => {
			document.body.style.overflow = "";
		};
	}, []);

	useEffect(() => {
		Sentry.captureException(error);
	}, [error]);

	return (
		<div className="flex h-dvh w-full flex-col items-center justify-center px-4 dark:bg-gray-900">
			<div className="text-center">
				<div className="flex items-center justify-center">
					<FrownIcon className="size-20 text-gray-500 dark:text-gray-400" />
				</div>

				<h1 className="mt-5 text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-50 sm:text-4xl">
					Oops, something went wrong
				</h1>

				<div className="mb-8 mt-5">
					<p className="hidden text-lg font-medium text-gray-500 dark:text-gray-400 sm:block">
						We&apos;re sorry, but it looks like there was an issue on our end.
					</p>

					<p className="text-lg font-medium text-gray-500 dark:text-gray-400">
						Please try again later or contact us if the problem persists.
					</p>
				</div>

				<div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
					<Link href="/app">
						<CustomButton
							variant="outline"
							size="lg"
						>
							Go back home
						</CustomButton>
					</Link>

					<Link href="/contact-us">
						<CustomButton
							variant="primary"
							size="lg"
						>
							Contact Support
						</CustomButton>
					</Link>
				</div>
			</div>
		</div>
	);
}
